export const GET_SYNC_STATUS_REQUEST = 'GET_SYNC_STATUS_REQUEST';
export const GET_SYNC_STATUS_SUCCESS = 'GET_SYNC_STATUS_SUCCESS';
export const GET_SYNC_STATUS_FAILURE = 'GET_SYNC_STATUS_FAILURE';
export const GET_SYNC_STATUS = 'GET_SYNC_STATUS';

export const START_SYNC_REQUEST = 'START_SYNC_REQUEST';
export const START_SYNC_SUCCESS = 'START_SYNC_SUCCESS';
export const START_SYNC_FAILURE = 'START_SYNC_FAILURE';
export const START_SYNC = 'START_SYNC';
